var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e6-flank-fix"},[(this.$slots.default)?_c('div',{staticClass:"fix-left"},[_c('div',{staticClass:"fix-left__content"},[_vm._t("default")],2)]):_vm._e(),(this.$slots.fixRight)?_c('div',{staticClass:"fix-right"},[_c('div',{staticClass:"fix-right__content"},[_vm._t("fixRight")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }